import { BaseService } from './base.service'
import { Uris } from '../common/constants'
import { ITeamMember, TeamMemberDto } from '../models/profile/member.model'
import { IMemberParameter } from '../models/profile/member.parameter'
import { AddressDto } from '../models/address/address.model'

export interface IReplacementMemberParam {
  role?:number[]
  q?:string,
  entity?:string,
  $skip?:number
  $limit?:number
}

export interface IProfileService {
  changeEmail: (email: string, password: string) => Promise<any>;
  getContacts: (params: any) => Promise<any>;
  getMembers: (memberParamter: IMemberParameter, skip: number, limit:number) => Promise<any>;
  getReplacementMembers: (params:IReplacementMemberParam) => Promise<any>;
  getEntityRoles: (params: any) => Promise<any>;
  getAllEntityRoles: () => Promise<any>;
  getCivilityLegalForm: () => Promise<any>;
  initMember: (opts?: ITeamMember) => ITeamMember;
  recordMember: (member: ITeamMember) => Promise<any>;
  updateMember: (memberId: number, member: ITeamMember, own: boolean, currentMember: any) => Promise<any>;
  updateMySignature: (userid: number, params: any) => Promise<any>;
  deleteMember: (memberId: number) => Promise<any>;
  deleteAndReplaceMember: (memberId: number, replacementId:number) => Promise<any>;
  cookMember: (member: ITeamMember) => Promise<any>;
  getClosingReasons: (params:any) => Promise<any>;
  createClosingReason: (data:any) => Promise<any>;
  patchClosingReason(id:number,data:any): Promise<any>;
  deleteClosingReason(id:number): Promise<any>;

  getTicketReasons: (params:any) => Promise<any>;
  createTicketReason: (data:any) => Promise<any>;
  patchTicketReason(id:number,data:any): Promise<any>;
  deleteTicketReason(id:number): Promise<any>;

  getTicketSubstatus: (params:any) => Promise<any>;
  createTicketSubstatu: (data:any) => Promise<any>;
  patchTicketSubstatu(id:number,data:any): Promise<any>;
  deleteTicketSubstatu(id:number): Promise<any>;
}
export class ProfileService extends BaseService implements IProfileService {
  async changeEmail (email: string, password: string) {
    return super.post(Uris.ProfileChangeEmail, {
      action: 'identityChange',
      password: password,
      new_email: email
    })
  }

  async getContacts (params: any): Promise<any> {
    return super.get(Uris.Search, params)
  }

  async getClosingReasons(params:any): Promise<any> {
    return super.get(Uris.TicketClosingReasons, params)
  }

  async createClosingReason(data:any): Promise<any> {
    return super.post(Uris.TicketClosingReasons, data)
  }

  async patchClosingReason(id:number,data:any): Promise<any> {
    return super.patch(Uris.TicketClosingReasons+'/'+id, data)
  }

  async deleteClosingReason(id:number): Promise<any> {
    return super.delete(Uris.TicketClosingReasons+'/'+id)
  }


  async getTicketReasons(params:any): Promise<any> {
    return super.get(Uris.TicketReasons, params)
  }

  async createTicketReason(data:any): Promise<any> {
    return super.post(Uris.TicketReasons, data)
  }

  async patchTicketReason(id:number,data:any): Promise<any> {
    return super.patch(Uris.TicketReasons+'/'+id, data)
  }

  async deleteTicketReason(id:number): Promise<any> {
    return super.delete(Uris.TicketReasons+'/'+id)
  }

  async getTicketSubstatus(params:any): Promise<any> {
    return super.get(Uris.TicketSubstatus, params)
  }

  async createTicketSubstatu(data:any): Promise<any> {
    return super.post(Uris.TicketSubstatus, data)
  }

  async patchTicketSubstatu(id:number,data:any): Promise<any> {
    return super.patch(Uris.TicketSubstatus+'/'+id, data)
  }

  async deleteTicketSubstatu(id:number): Promise<any> {
    return super.delete(Uris.TicketSubstatus+'/'+id)
  }

  async getMembers (memberParameter: IMemberParameter, skip: number, limit:number) : Promise<any> {
    const roles = memberParameter.current_filter === 'team' ? memberParameter.team_roles : memberParameter.external_roles

    let cookedParam: any = {}
    cookedParam.$skip = skip
    cookedParam.$limit = limit
    if (memberParameter.key) cookedParam.q = memberParameter.key.replace('#', '')

    if (roles.length) cookedParam.role = roles.join()
    else cookedParam.entity = memberParameter.current_filter

    return super.get(Uris.Search, cookedParam)
       .then(response => Promise.resolve(response))
        .catch(err => Promise.reject(err))
  }

  getReplacementMembers(params:IReplacementMemberParam): Promise<any> {
    return super.get(Uris.Search, params)
  }

  async getEntityRoles (params) : Promise<any> {
    return super.get(Uris.EntityRoles, params)
        .then(response => Promise.resolve(response))
        .catch(err => Promise.reject(err))
  }

  async getAllEntityRoles (): Promise<any> {
    return Promise.all(
      [
        super.get(`${Uris.EntityRoles}?type=internal`),
        super.get(`${Uris.EntityRoles}?type=external`)
          // super.get(`${Uris.EntityRoles}`)
      ]
      ).then(responses => {
        return Promise.resolve({
          'internal': responses[0] || [],
          'external': responses[1] || [],
            ['all'] : ( (responses[0] || []) as any[] ).concat(responses[1] || [])
        })
      })
        .catch(err => Promise.reject(err))
  }

  async getCivilityLegalForm (): Promise<any> {
    return super.get(Uris.CivilityLegalForm)
        .then((response: any) => {
          return Promise.resolve(response ? response.data : [])
        })
        .catch(err => Promise.reject(err))
  }

  initMember (opts?: ITeamMember) {
    return new TeamMemberDto(opts || {
      blocks: [],
      apartments: [],
      address: new AddressDto()
    })
  }

  recordMember (member: ITeamMember) : Promise<any> {
    return this.cookMember(member)
                  .then(cookedMember => {
                    return super.post(Uris.Account, { ...cookedMember })
                          .then(response => Promise.resolve(response))
                          .catch(err => Promise.reject(err))
                  })
  }

  updateMember (memberId: number, member: ITeamMember, own: boolean, currentMember: any): Promise<any> {
    return this.cookMember(member, 'update', own, currentMember)
        .then(cookedMember => {
          return super.patch(`${Uris.Account}/${memberId}`, { ...cookedMember })
               .then(updatedMember => Promise.resolve(updatedMember))
               .catch(err => Promise.reject(err))
        })
  }

  updateMySignature (userid: number, params: { signature: string }): Promise<any> {
    return super.patch(`${Uris.Me}/${userid}`, params)
  }

  deleteMember (memberId: number) : Promise<any> {
    return super.delete(`${Uris.Account}/${memberId}`)
        .then(deletedMember => Promise.resolve(deletedMember))
        .catch(err => Promise.reject(err))
  }

  deleteAndReplaceMember(memberId: number, replacementId:number | null) : Promise<any> {
    if(replacementId)
    {
      return super.delete(`${Uris.Account}/${memberId}?replace_user=true&replacement_id=${replacementId}`)
    } else {
      return super.delete(`${Uris.Account}/${memberId}`)
    }
  }

  cookMember (member: any, task: string= 'create', own: boolean=false,
              currentMember: any = null) : Promise<any> {
    const {
      civility, role, blocks, apartments,
      email, fake_email, password, firstname, lastname, cellphone, landline, parent_entity,
      num_siret, code_ape, num_tva, specialization, old_password, new_password, trigram, charPb1, charPb2

    } = member
    const sendLegalEntity = num_tva || code_ape || num_siret
    let cooked_member = {
      user_role:role,
      civility,
      firstname,
      lastname,
      email,
      fake_email,
      password,
      cellphone,
      landline,
      trigram,
      parent_entity,
      char_pb : {
        level_1: charPb1,
        level_2: charPb2
      },
      ...(old_password && new_password) && { old_password, new_password },
      ...specialization /* && specialization.length > 0*/ && { problem_solver: specialization },
      ...sendLegalEntity &&
        {
          legal_entity: {
            tva: num_tva,
            ape: code_ape,
            siret: num_siret
          }
        }
    }
    if (!own) {
      const { countryCode, iris_code, ...address } = member.address
      if (member.address.isNotEmpty()) cooked_member['address'] = address
      cooked_member['relations'] = {
        block: blocks || [],
        apartments: apartments || []
      }
    }
    if (task === 'create') {
      cooked_member['user_role'] = role
      if (member.password && member.password.trim() === '')
        delete cooked_member.password
    } else if (task === 'update') {
      if (member.password && member.password.trim() === '')
        delete cooked_member.password
      if (member.role === currentMember.role)
        delete cooked_member.user_role
      if (member.civility === currentMember.civility)
        delete cooked_member.civility
      if (member.firstname === currentMember.firstname)
        delete cooked_member.firstname
      if (member.lastname === currentMember.lastname)
        delete cooked_member.lastname
      if (member.email === currentMember.email)
        delete cooked_member.email
      if (member.cellphone === currentMember.cellphone)
        delete cooked_member.cellphone
      if (member.landline === currentMember.landline)
        delete cooked_member.landline
      if (member.trigram === currentMember.trigram)
        delete cooked_member.trigram
      if (member.parent_entity &&
        member.parent_entity.id === currentMember.parent_entity.id)
        delete cooked_member.parent_entity
      if (member.specialization === currentMember.specialization)
        delete cooked_member.problem_solver
      if (member.address &&
          member.address.city === currentMember.address.city &&
          member.address.country === currentMember.address.country &&
          member.address.line1 === currentMember.address.line1 &&
          member.address.line2 === currentMember.address.line2 &&
          member.address.zip_code === currentMember.address.zip_code) {
        delete (cooked_member as any).address
      }
      if (member.blocks === currentMember.blocks &&
          member.apartments === currentMember.apartments)
        delete (cooked_member as any).relations
    }
    return Promise.resolve(cooked_member)
  }
}



// WEBPACK FOOTER //
// ./src/services/profile.service.ts